import * as classnames from "classnames";

import { ApplicantChallengeMini, QuickHelp, Msg } from "../";
import { ApplicantExamModel } from "../../models";
import { formatTimeLeftString } from "../../services/date";
import Message from "../../services/message";

/**
 * Prop interface
 */
export interface ApplicantChallengeListProps {
  exam: ApplicantExamModel;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantChallengeList({
  exam,
  className,
}: ApplicantChallengeListProps) {
  const { challengesSets, challenges } = exam;

  const rootStyle = classnames(
    "code-c-applicant-challenge-list",
    "challenge-list",
    {
      [`${className}`]: Boolean(className),
    },
  );

  let challengeIndex = 0;
  const challengeSetContents = challengesSets.map((challengeSet) => {
    if (challengeSet.isOptionalSet) {
      return (
        <div key={challengeSet.id}>
          <ApplicantChallengeMini
            mode="text"
            label={
              <div>
                <Msg id="challenge.optional" />
                <span className="code-c-applicant-challenge-list__optional-sub-title">
                  {" "}
                  (
                  <Msg
                    id={
                      challengeSet.numberChallengesToTake > 0
                        ? "challenge.optionalMessage1"
                        : "challenge.optionalMessage2"
                    }
                    values={{ number: challengeSet.numberChallengesToTake }}
                  />
                  )
                </span>
              </div>
            }
            index={challengeIndex++}
          />
          <div className="code-c-applicant-challenge-list__optional-container">
            {challengeSet.challenges.map((challenge, index) => (
              <ApplicantChallengeMini
                mode="challenge"
                size="small"
                key={challenge.id}
                index={index}
                challenge={challenge}
              />
            ))}
          </div>
        </div>
      );
    } else {
      return challengeSet.challenges.map((challenge) => {
        return (
          <ApplicantChallengeMini
            mode="challenge"
            key={challenge.id}
            index={challengeIndex++}
            challenge={challenge}
          />
        );
      });
    }
  });

  return (
    <div className={rootStyle}>
      <div className="code-c-applicant-challenge-list__header">
        <div className="code-c-applicant-challenge-list__total">
          <Msg id="editor-exam-detail.challenge.total" />
          {challenges.length}
          <Msg id="challenge.countSuffix" />
        </div>
        <div>
          <Msg id="editor-exam-detail.exam.requiredTime" />
          {": "}
          <strong>
            <Msg id="editor-exam-detail.exam.requiredTimeApproximately" />
            {formatTimeLeftString(exam.estimatedCompletionTime * 60)}
          </strong>
          <QuickHelp
            text={Message.getMessageByKey(
              "editor-exam-detail.exam.requiredTimeQuickHelp",
            )}
            maxSize="large"
          />
        </div>
      </div>
      <div className="code-c-applicant-challenge-list__challenges">
        {challengeSetContents}
      </div>
    </div>
  );
}
